import { useContext } from 'react';
import { useMst } from '../../../models';
import { useTranslation } from 'react-i18next';
import get from 'lodash/get';
import { observer } from 'mobx-react-lite';
import { getLocalizedField, getLocalizedFieldOrI18n } from 'helpers/localizedField';
import Txt from 'components/common/ui/Txt';

const WorkInfo = observer(() => {
  const { attend: attendStore, user } = useMst();
  const { t } = useTranslation();
  const selectedWorkplace = get(attendStore, 'selectedWorkplace', {});
  const { workStartTime, workEndTime, text: dayText } = get(attendStore, 'datas.info', {});

  // 근로제명(표준근로제 등)·스케줄 제목: 번역 키가 있으면 번역, 없으면 원본
  const workName = attendStore?.get?.workName ? t(attendStore.get.workName) : '';

  ////////////////////////////////////////////////////////////////////////////////////
	//------------------------------------- 화면 -------------------------------------//
  return (
    <div className='info_box'>
      <Txt color='gray' className='location'>
        {getLocalizedField(selectedWorkplace) || selectedWorkplace?.name || '-'}
      </Txt>
      <div className='type_box'>
        {/* 근무계획이 있으면 근로제명 + 시간, 없으면(휴일/휴가) 서버의 유형명(text) 표시 */}
        {workName ? (
          <>
            <Txt as='span' color='gray' className='time'>{workName}</Txt>
            {workStartTime && workEndTime && (
              <Txt as='span' color='gray'>{workStartTime} ~ {workEndTime}</Txt>
            )}
          </>
        ) : (
          dayText && <Txt as='span' color='gray' className='time'>{t(dayText)}</Txt>
        )}
      </div>
    </div>
  );
});

export default WorkInfo;